export default __webpack_public_path__ + "static/media/Truck2.416b8cf7.gif";